export default __webpack_public_path__ + "static/media/SKOCZNOSC.7f3c8344.png";